import React, { useState, useEffect } from "react";
import {
  Box,
  Table,
  Thead,
  Tbody,
  Tr,
  Th,
  Td,
  Text,
  Spinner,
  Input,
  Button,
  Select,
  Flex,
  Checkbox,
  Menu,
  MenuButton,
  MenuList,
  MenuItem,
  IconButton,
  useDisclosure,
  Center,
} from "@chakra-ui/react";
import { FaEllipsisV } from "react-icons/fa"; // Importing HamburgerIcon for the Menu button
import { BASE_URL } from "../../../Globalapi/Globalapi";

const FeesGroupTable = () => {
  const [feesData, setFeesData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [searchTerm, setSearchTerm] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [searchOption, setSearchOption] = useState("");

  useEffect(() => {
    fetchFeesData();
  }, []);

  const fetchFeesData = async () => {
    setLoading(true);
    try {
      const response = await fetch(
        `${BASE_URL}/admin/Fees/fees_master/list_fee_master.php`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            org_id: sessionStorage.getItem("cmp_id"),
          }),
        }
      );

      const result = await response.json();
      console.log("====================================");
      console.log(result);
      console.log("====================================");
      if (result.success && result.data) {
        setFeesData(result.data);
      } else {
        console.error(result.message || "Failed to fetch fees data.");
      }
    } catch (error) {
      console.error("Error fetching fees data:", error);
    } finally {
      setLoading(false);
    }
  };

  const filteredFeesData = feesData.filter((fee) => {
    if (searchOption === "fee_name") {
      return fee.fee_name.toLowerCase().includes(searchTerm.toLowerCase());
    }
    if (searchOption === "class_name") {
      return fee.class_name.toLowerCase().includes(searchTerm.toLowerCase());
    }
    return true; // Show all if no filter is applied
  });

  const indexOfLastRow = currentPage * rowsPerPage;
  const indexOfFirstRow = indexOfLastRow - rowsPerPage;
  const currentData = filteredFeesData.slice(indexOfFirstRow, indexOfLastRow);
  const totalPages = Math.ceil(filteredFeesData.length / rowsPerPage);

  const handleDelete = async (feeMasterId) => {
    const orgId = sessionStorage.getItem("cmp_id"); // Use the correct org_id if needed

    try {
      const response = await fetch(
        `${BASE_URL}/admin/Fees/fees_master/delete_fee_master.php`,
        {
          method: "DELETE",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            fee_master_id: feeMasterId,
            org_id: orgId,
          }),
        }
      );

      const result = await response.json();
      console.log("====================================");
      console.log(result);
      console.log("====================================");
      if (result.success) {
        alert(result.message);
        fetchFeesData(); // Re-fetch data after deletion
      } else {
        alert(result.message);
      }
    } catch (error) {
      console.error("Error deleting fee:", error);
      alert("Error deleting fee");
    }
  };

  return (
    <Box p={6}>
      {loading ? (
        <Spinner size="lg" />
      ) : (
        <Box p={1}>
          <Flex
            justify="space-between"
            borderRadius={5}
            className="sb1"
            mb={1}
            p={3}
            align="center"
            direction={{ base: "column", md: "row" }}
            gap={4} // add spacing between children
            w="100%"
          >
            {/* Rows Per Page */}
            <Flex align="center" w={{ base: "100%", md: "auto" }}>
              <Text mr={2} minW="100px">
                Rows Per Page
              </Text>
              <Select
                value={rowsPerPage}
                onChange={(e) => setRowsPerPage(Number(e.target.value))}
                w={{ base: "100%", md: "100px" }}
              >
                <option value={10}>10</option>
                <option value={20}>20</option>
                <option value={50}>50</option>
              </Select>
            </Flex>

            {/* Search Section */}
            <Flex
              align="center"
              w={{ base: "100%", md: "auto" }}
              gap={2}
              mt={{ base: 3, md: 0 }}
            >
              <Select
                placeholder="Select Option"
                value={searchOption}
                onChange={(e) => setSearchOption(e.target.value)}
                w={{ base: "40%", md: "200px" }}
              >
                <option value="fee_name">Fee Name</option>
                <option value="class_name">Class Name</option>
              </Select>

              <Input
                placeholder={`Search by ${
                  searchOption === "fee_name" ? "Fee Name" : "Class Name"
                }`}
                value={searchTerm}
                onChange={(e) => setSearchTerm(e.target.value)}
                w={{ base: "60%", md: "300px" }}
              />
            </Flex>
          </Flex>

          <Box borderWidth="1px" borderRadius="md" overflowX="auto">
            <Table
              sx={{
                "tbody tr:nth-of-type(even)": { backgroundColor: "#f2f4f8" },
              }}
              colorScheme="gray"
              size="md"
            >
              <Thead>
                <Tr>
                  <Th>
                    <Checkbox />
                  </Th>
                  <Th>Class</Th>
                  <Th>Fee Name</Th>
                  <Th>Fee Group Name</Th>
                  <Th>Start Date</Th>
                  <Th>Due Date</Th>
                  <Th>Fee Amount</Th>
                  <Th>Fine Details</Th>
                  <Th textAlign="center">Actions</Th>
                </Tr>
              </Thead>
              <Tbody>
                {filteredFeesData.length > 0 ? (
                  currentData.map((fee, index) => (
                    <Tr key={index}>
                      <Td py="12px" px="20px" textAlign="left">
                        <Checkbox />
                      </Td>
                      <Td>{fee.class_name}</Td>
                      <Td>{fee.fee_name}</Td>
                      <Td>{fee.fee_group_name}</Td>
                      <Td>{fee.start_date}</Td>
                      <Td>{fee.due_date}</Td>
                      <Td>
                        {fee.fee_amounts?.length
                          ? fee.fee_amounts
                              .map(
                                (amount) =>
                                  `${amount.fee_type_name}: ${amount.amount}`
                              )
                              .join(", ")
                          : "N/A"}
                      </Td>
                      <Td textAlign="center">
                        {fee.fine_intervals?.length
                          ? fee.fine_intervals
                              .map(
                                (interval) =>
                                  `Interval: ${interval.intervals}, Fine: ${
                                    interval.fine_amount !== "0.00"
                                      ? interval.fine_amount
                                      : `${interval.fine_percentage}%`
                                  }`
                              )
                              .join("; ")
                          : "N/A"}
                      </Td>
                      <Td>
                        <Box textAlign="center">
                          <Menu>
                            <MenuButton
                              as={IconButton}
                              icon={<FaEllipsisV />}
                              aria-label="Options"
                              size="sm"
                            />
                            <MenuList>
                              <MenuItem>Edit</MenuItem>
                              <MenuItem
                                onClick={() => handleDelete(fee.fee_master_id)}
                              >
                                Delete
                              </MenuItem>
                            </MenuList>
                          </Menu>
                        </Box>
                      </Td>
                    </Tr>
                  ))
                ) : (
                  <Tr>
                    <Td colSpan="9" textAlign="center">
                      No data found.
                    </Td>
                  </Tr>
                )}
              </Tbody>
            </Table>
          </Box>

          <Flex
            justify="flex-end"
            borderRadius={5}
            className="sb1"
            mt={1}
            p={4}
          >
            <Button
              onClick={() => setCurrentPage(currentPage - 1)}
              isDisabled={currentPage === 1}
            >
              Prev
            </Button>
            {Array.from({ length: totalPages }, (_, i) => (
              <Button
                key={i}
                onClick={() => setCurrentPage(i + 1)}
                colorScheme={currentPage === i + 1 ? "teal" : "gray"}
                mx={1}
              >
                {i + 1}
              </Button>
            ))}
            <Button
              onClick={() => setCurrentPage(currentPage + 1)}
              isDisabled={currentPage === totalPages || totalPages === 0}
            >
              Next
            </Button>
          </Flex>
        </Box>
      )}
    </Box>
  );
};

export default FeesGroupTable;
